import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";

import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import Basic from "layouts/authentication/sign-in/basic";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Register from "layouts/authentication/sign-up/cover";
import Financialreport from "Reports/financialreport";
import Devicereport from "Reports/devicereport";
import Dealerreport from "Reports/dealerreport";
import OTPVerification from "layouts/authentication/sign-up/cover/OTPVerification";
import Privacypolicy from "components/privacypolicy";
import Termsandcondition from "components/termsandconditions";
import DeviceType from "track/Devicetype";

import Location from "track/Location";

import Dashboard from "Dashboard";
import ForgotPassword from "components/forgotpassword";
import Validation from "components/validation";
import ResetPassword from "components/resetpassword";
import Security from "components/security";
import Notification from "components/notifications";
import SOSNotification from "components/SOSNotification";

import Customers from "track/Customers";
import ProfileIcon from "components/profile";

import CreateCustomerRegistration from "track/CreateCustomers";
import CustomerDetails from "track/CustomerDetails";
import AdminDasboard from "track/Admindashboard";
import CustomerProfileDetails from "track/CustomerProfileDetails";

import SMTPConfigurationDetails from "track/Smtp";

import CareCoordinatorsDetails from "track/CareCoordinators";
import CreateCareCoordinators from "track/CreateCareCoordinators";
import ViewCareCoordinator from "track/ViewCareCoordinator";
import DoctorsRegistration from "track/Doctors";
// import CreateDoctorsProfile from "track/CreateDoctorProfile";
import ViewDoctorProfile from "track/ViewDoctorProfile";
import CreateDoctorsProfile from "track/CreateDoctorProfile";
import PatientRegistration from "track/Patients";
import CreatePatientProfile from "track/CreatePatients";
import ViewPatientProfile from "track/ViewPatient";
import PatientViewDetails from "track/PatientViewDetails";
import DoctorLoginPatientDetails from "track/DoctorLoginPatientDetails";
import ViewDoctorDetails from "track/ViewDoctorDetails";
import PatientLoginDoctorDetails from "track/PatientLoginDoctorDetails";
import CreateDevicemapping from "track/CreateDeviceMapping";
import Devicemapping from "track/DeviceMapping";
import DeviceData from "track/DeviceData";
import AddDeviceData from "track/AddDeviceData";
import AddHospitalData from "track/AddHospital";
import HospitalProfile from "track/HospitalProfile";
import DoctorMapDetails from "track/DoctormapDeatils";
import DoctorMapping from "track/Doctormapping";
import ViewHospitalprofile from "track/ViewHospitalProfile";
import HospitalDoctor from "track/HospitalDoctor";
import PrivateRoute from "track/privateRoute";
import DoctorPatientMapping from "track/DPmapping";
import CreateDoctorPatientMapping from "track/CretaeDP";
import CareCoordinatorsDashboard from "track/CareCoordinatorDashboard";
import CreateDeviceDetails from "track/CreateDeviceDetails";
import ViewDeviceData from "track/ViewDeviceData";
import SuperDashboard from "track/SuperDashboard";
import NotificationDetails from "track/NotificationDetails";
import DoctorNotificationDetails from "track/DoctorNotification";
import PatientDashboard from "track/PatientDashboard";
import DoctorDashboard from "track/DoctorDashboard";
import DeviceInventory from "track/DeviceDetails";
import RegisterDevice from "track/CreateDeviceDetails";
import PatientLoginDeviceDetails from "track/PatientLoginDeviceDetails";
import MyReadings from "track/Myreadings";
import Myprescription from "track/Myprescription";
import SnapMeal from "track/SnapMeal";
import AddThreshold from "track/AddThreshold";
import Threshold from "track/Threshold";
import UpdateThreshold from "track/UpdateThreshold";
import AccountDeletionPolicy from "track/AccountDeletionPolicy";


export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });



  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        <SOSNotification />
        {layout === "dashboard" && pathname !== "/AccountDeletionPolicy" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="Dashboard"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />

          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/#" />} />
          <Route path="/" element={<Basic />} />
          <Route path="/register" element={<Register />} />
          <Route path="/OTPVerification" element={<OTPVerification />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/termsandconditions" element={<Termsandcondition />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/security" element={<Security />} />
          <Route path="/AccountDeletionPolicy" element={<AccountDeletionPolicy />} />

          <Route element={<PrivateRoute />}>

            <Route path="/devicetype" element={<DeviceType />} />
            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/Location" element={<Location />} />
            <Route path="/resetpassword" element={<ResetPassword />} />


            <Route path="/CreateCustomers" element={<CreateCustomerRegistration />} />
            <Route path="/CustomerDetails" element={<CustomerDetails />} />


            <Route path="/CreateCareCoordinators" element={<CreateCareCoordinators />} />
            <Route path="/CareCoordinatorsDetails" element={<CareCoordinatorsDetails />} />
            <Route path="/CustomerProfileDetails" element={<CustomerProfileDetails />} />


            <Route path="/Admindasboard" element={<AdminDasboard />} />



            <Route path="/SMTPConfigurationDetails" element={<SMTPConfigurationDetails />} />


            <Route path="/profile" element={<ProfileIcon />} />
            <Route path="/validation" element={<Validation />} />
            <Route path="/financialreport" element={<Financialreport />} />
            <Route path="/dealerreport" element={<Dealerreport />} />

            <Route path="/notification" element={<Notification />} />
            <Route path="/view-care-coordinator/:id" element={<ViewCareCoordinator />} />
            {/* <Route path="/Doctors" element={<DoctorsRegistration />} />
        <Route path="/CreateDoctorsProfile" element={<CreateDoctorsProfile />} /> */}
            <Route path="/PatientRegistration" element={<PatientRegistration />} />
            <Route path="/CreatePatientProfile" element={<CreatePatientProfile />} />        <Route path="/Doctors" element={<DoctorsRegistration />} />
            <Route path="/CreateDoctorsProfile" element={<CreateDoctorsProfile />} />
            <Route path="/ViewDoctorProfile/:id" element={<ViewDoctorProfile />} />

            <Route path="/ViewPatientProfile/:id" element={<ViewPatientProfile />} />
            <Route path="/DoctorPatientmapping" element={<DoctorPatientMapping />} />
            <Route path="/CreateDoctorPatientMapping" element={<CreateDoctorPatientMapping />} />

            <Route path="/PatientViewDetails/:id/:doctorId" element={<PatientViewDetails />} />
            <Route path="/DoctorLoginPatientDetails" element={<DoctorLoginPatientDetails />} />

            <Route path="/ViewDoctorDetails/:id/:patientId" element={<ViewDoctorDetails />} />
            <Route path="/PatientLoginDoctorDetails" element={<PatientLoginDoctorDetails />} />
            <Route path="/CreateDevicemapping" element={<CreateDevicemapping />} />
            <Route path="/DeviceData" element={<DeviceData />} />

            <Route path="/AddDeviceData" element={<AddDeviceData />} />
            <Route path="/HospitalProfile" element={<HospitalProfile />} />

            <Route path="/AddHospitalData" element={<AddHospitalData />} />


            <Route path="/ViewDeviceData/:id" element={<ViewDeviceData />} />

            <Route path="/DeviceInventory" element={<DeviceInventory />} />
            <Route path="/RegisterDevice" element={<RegisterDevice />} />
            <Route path="/DoctorMapDetails" element={<DoctorMapDetails />} />
            <Route path="/DoctorMapping" element={<DoctorMapping />} />
            <Route path="/ViewHospitalProfile/:id" element={<ViewHospitalprofile />} />
            <Route path="/HospitalDoctor" element={<HospitalDoctor />} />
            <Route path="/Dashboard" element={<CareCoordinatorsDashboard />} />
            <Route path="/SuperDashboard" element={<SuperDashboard />} />

            <Route path="/NotificationDetails" element={<NotificationDetails />} />
            <Route path="/DoctorNotificationDetails" element={<DoctorNotificationDetails />} />
            < Route path="/PatientDashboard" element={<PatientDashboard />} />
            < Route path="/DoctorDashboard" element={<DoctorDashboard />} />

            < Route path="/PatientLoginDeviceDetails" element={<PatientLoginDeviceDetails />} />
            < Route path="/MyReadings" element={<MyReadings />} />

            < Route path="/Myprescription" element={<Myprescription />} />
            < Route path="/SnapMeal" element={<SnapMeal />} />

<Route path="/Threshold/:id" element={<Threshold />} />
<Route path="/AddThreshold/:id" element={<AddThreshold />} />

<Route path="/UpdateThreshold/:id" element={<UpdateThreshold />} />

          </Route>
        </Routes>
        <ToastContainer />
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      <SOSNotification />
      {layout === "dashboard" && pathname !== "/AccountDeletionPolicy" && (

        <>


          <Sidenav
            color={sidenavColor}
            brandName={
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <Link to="/dashboard">
    <img 

       src={process.env.REACT_APP_IMAGE_PATH} // Replace with your actual image path
      alt="logo1" 
      style={{ width: "134px", height: "46px" }} 
    />
    </Link> */}
                {/* <span>RPM</span> */}

              </div>
            }
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />

          <Configurator />

        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/#" />} />
        <Route path="/" element={<Basic />} />
        <Route path="/register" element={<Register />} />
        <Route path="/termsandconditions" element={<Termsandcondition />} />
        <Route path="/security" element={<Security />} />
        <Route path="/OTPVerification" element={<OTPVerification />} />
        <Route path="/privacypolicy" element={<Privacypolicy />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        
                <Route path="/AccountDeletionPolicy" element={<AccountDeletionPolicy />} />

        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/devicetype" element={<DeviceType />} />
          <Route path="/Customers" element={<Customers />} />
          <Route path="/CreateCustomers" element={<CreateCustomerRegistration />} />
          <Route path="/CustomerDetails" element={<CustomerDetails />} />

          <Route path="/CreateCareCoordinators" element={<CreateCareCoordinators />} />

          <Route path="/CareCoordinatorsDetails" element={<CareCoordinatorsDetails />} />
          <Route path="/Admindasboard" element={<AdminDasboard />} />

          <Route path="/CustomerProfileDetails" element={<CustomerProfileDetails />} />

          <Route path="/DeviceInventory" element={<DeviceInventory />} />
          <Route path="/RegisterDevice" element={<RegisterDevice />} />

          <Route path="/notification" element={<Notification />} />
          <Route path="/Location" element={<Location />} />
          <Route path="/validation" element={<Validation />} />
          <Route path="/resetpassword" element={<ResetPassword />} />


          <Route path="/financialreport" element={<Financialreport />} />
          <Route path="/devicereport" element={<Devicereport />} />
          <Route path="/dealerreport" element={<Dealerreport />} />

          <Route path="/profile" element={<ProfileIcon />} />

          <Route path="/view-care-coordinator/:id" element={<ViewCareCoordinator />} />
          <Route path="/Doctors" element={<DoctorsRegistration />} />

          <Route path="/CreateDoctorsProfile" element={<CreateDoctorsProfile />} />
          <Route path="/PatientRegistration" element={<PatientRegistration />} />
          <Route path="/CreatePatientProfile" element={<CreatePatientProfile />} />
          <Route path="/CreateDoctorsProfile" element={<CreateDoctorsProfile />} />
          <Route path="/ViewDoctorProfile/:id" element={<ViewDoctorProfile />} />
          <Route path="/ViewPatientProfile/:id" element={<ViewPatientProfile />} />

          <Route path="/DoctorPatientmapping" element={<DoctorPatientMapping />} />

          <Route path="/CreateDoctorPatientMapping" element={<CreateDoctorPatientMapping />} />
          <Route path="/PatientViewDetails/:id/:doctorId" element={<PatientViewDetails />} />

          <Route path="/DoctorLoginPatientDetails" element={<DoctorLoginPatientDetails />} />
          <Route path="/ViewDoctorDetails/:id/:patientId" element={<ViewDoctorDetails />} />
          <Route path="/PatientLoginDoctorDetails" element={<PatientLoginDoctorDetails />} />

          <Route path="/CreateDevicemapping" element={<CreateDevicemapping />} />
          <Route path="/Devicemapping" element={<Devicemapping />} />
          <Route path="/DeviceData" element={<DeviceData />} />

          <Route path="/AddDeviceData" element={<AddDeviceData />} />

          <Route path="/HospitalProfile" element={<HospitalProfile />} />

          <Route path="/AddHospitalData" element={<AddHospitalData />} />
          <Route path="/DoctorMapDetails" element={<DoctorMapDetails />} />
          <Route path="/DoctorMapping" element={<DoctorMapping />} />
          <Route path="/ViewHospitalProfile/:id" element={<ViewHospitalprofile />} />
          <Route path="/ViewDeviceData/:id" element={<ViewDeviceData />} />

          <Route path="/HospitalDoctor" element={<HospitalDoctor />} />
          <Route path="/Dashboard" element={<CareCoordinatorsDashboard />} />

          <Route path="/SuperDashboard" element={<SuperDashboard />} />
          <Route path="/NotificationDetails" element={<NotificationDetails />} />

          <Route path="/DoctorNotificationDetails" element={<DoctorNotificationDetails />} />
          < Route path="/PatientDashboard" element={<PatientDashboard />} />

          < Route path="/DoctorDashboard" element={<DoctorDashboard />} />
          < Route path="/PatientLoginDeviceDetails" element={<PatientLoginDeviceDetails />} />

          < Route path="/MyReadings" element={<MyReadings />} />
          < Route path="/Myprescription" element={<Myprescription />} />

          < Route path="/SnapMeal" element={<SnapMeal />} />
<Route path="/Threshold/:id" element={<Threshold />} />
<Route path="/AddThreshold/:id" element={<AddThreshold />} />
<Route path="/UpdateThreshold/:id" element={<UpdateThreshold />} />

        </Route>
      </Routes>
      <ToastContainer />
      {/* {pathname !== "/" && <FooterInfo />} */}

    </ThemeProvider>
  );
}
